// extracted by mini-css-extract-plugin
export default {"container":"Y4wzla","text":"WSPvQF","block":"FBlldl"};